import React from "react";

const Footer = () => {
  return (
    <footer className="container text-center">
      <p>
        Diseñado por el profesor{" "}
        <a
          href="https://jimeneza14.github.io/cv/"
          target="_blank"
          title="Pagina web Angel Jimenez"
        >
          Angel R. Jimenez G.
        </a> <br />
        Todos los derechos reservado 2020 - 2040
      </p>
    </footer>
  );
};
export default Footer;
